// Vendor Libs
import {cloneDeep} from 'lodash';

const requestState = {
    fetching: false,
    error: null,
};

const initialState = {
    requests: {
        FINGERPRINT: {...requestState},
        INTRO: {...requestState},
        CREDITS: {...requestState},
    },
    lastFulfilledType: null,
};

const actions = {
    GENERATE_MARKER: (state, {markerType}) => ({
        ...state,
        requests: {
            ...state.requests,
            [markerType]: {fetching: true, error: null},
        },
        lastFulfilledType: null,
    }),

    GENERATE_MARKER_FULFILLED: (state, {markerType}) => ({
        ...state,
        requests: {
            ...state.requests,
            [markerType]: {fetching: false, error: null},
        },
        lastFulfilledType: markerType,
    }),

    GENERATE_MARKER_REJECTED: (state, {markerType, error}) => ({
        ...state,
        requests: {
            ...state.requests,
            [markerType]: {fetching: false, error},
        },
    }),

    GENERATE_MARKER_RESET: () => getInitialState(),
};

function getInitialState() {
    return cloneDeep(initialState);
}

const reducer = (state = getInitialState(), action) =>
    actions[action.type] ? actions[action.type](state, action) : state;

export default reducer;
